import { render, staticRenderFns } from "./LandingSalesPerson.vue?vue&type=template&id=6cee8ebd&scoped=true&lang=pug&"
import script from "./LandingSalesPerson.vue?vue&type=script&lang=js&"
export * from "./LandingSalesPerson.vue?vue&type=script&lang=js&"
import style0 from "./LandingSalesPerson.vue?vue&type=style&index=0&id=6cee8ebd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cee8ebd",
  null
  
)

/* custom blocks */
import block0 from "./LandingSalesPerson.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VChip,VContainer,VIcon,VSelect})
